/** Turn API / Axios / Vercel 502 bodies into a string React can render. */
export function formatApiError(err, fallback = "Request failed") {
  if (err == null || err === "") return fallback;
  if (typeof err === "string" || typeof err === "number") return String(err);
  const status = err.response?.status || err.status;
  if (status === 502 || status === 504 || status === 524) {
    return "The server took too long (often Generate). Wait a minute if Render is waking up, then try again.";
  }
  const data = err.response?.data ?? err.data ?? err;
  if (typeof data === "string" && data.trim()) return data.replace(/<[^>]+>/g, " ").slice(0, 400);
  const pick = (v) => {
    if (v == null) return "";
    if (typeof v === "string") return v;
    if (typeof v === "number") return String(v);
    if (typeof v === "object") return String(v.message || v.error || v.code || "");
    return "";
  };
  const fromErrorField = pick(data?.error);
  if (fromErrorField) return fromErrorField;
  const fromMessage = pick(data?.message);
  if (fromMessage) return fromMessage;
  if (typeof err.message === "string" && err.message && err.message !== "[object Object]") {
    if (/502|bad gateway|network error/i.test(err.message)) {
      return "The server took too long (often Generate). Wait and try again — Render may be waking up.";
    }
    return err.message;
  }
  return fallback;
}
